module.exports = __webpack_public_path__ + "img/seeker.c0f1efc7.svg";